import React from 'react';
import { Container } from '@mui/material';
import { GuestProfileForm } from '../../components/Auth/GuestProfileForm';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LoadingIndicator } from '../../components/LoadingIndicator';

export const GuestProfilePage = () => {
  const { guest, isLoading } = useAuth();
  const navigate = useNavigate();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!guest) {
    navigate('/sign-in', { replace: true });
  }

  return (
    <Container maxWidth="md" sx={{ padding: 3 }}>
      <GuestProfileForm />
    </Container>
  );
};
